import { SvgIcon } from '@mui/material';

const Shield = () => (
  <SvgIcon
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 25, fill: 'none' }}
    data-testid="shieldIcon"
  >
    <path
      d="M12.0048 22.2499C11.8426 22.248 11.6831 22.208 11.5391 22.133C10.0863 21.3365 8.72043 20.3895 7.46392 19.3075C6.57989 18.5675 5.79114 17.7199 5.11585 16.784C4.4462 15.9112 4.05698 14.8543 4 13.7539V6.41734C4.00334 6.11763 4.11244 5.82882 4.30786 5.60225C4.50329 5.37569 4.77238 5.22607 5.06732 5.17998C6.16346 4.96907 7.22926 4.62215 8.24017 4.14721C9.24313 3.72451 10.1965 3.1919 11.0831 2.55908C11.3402 2.37101 11.6481 2.26569 11.9661 2.25704C12.1409 2.24318 12.3168 2.26445 12.4834 2.31966C12.65 2.37487 12.804 2.46288 12.9363 2.57855C13.8008 3.21342 14.7352 3.74631 15.721 4.16668C16.7344 4.63114 17.8045 4.95876 18.9036 5.141C19.2046 5.17878 19.4818 5.32508 19.6835 5.55269C19.8851 5.7803 19.9976 6.07371 20 6.37836V14.2118C19.9275 15.2152 19.5286 16.1669 18.8648 16.9204C18.1722 17.7975 17.3883 18.5978 16.5264 19.3075C15.2709 20.3814 13.9198 21.337 12.49 22.1622C12.3385 22.2329 12.1714 22.2631 12.0048 22.2499ZM6.13464 7.19678V13.7539C6.19777 14.4041 6.45096 15.0211 6.86235 15.5272C7.43584 16.3146 8.1039 17.028 8.85142 17.6512C9.83023 18.4927 10.8787 19.2489 11.9854 19.9116C13.0974 19.212 14.1607 18.4372 15.168 17.5927C15.9111 16.9812 16.5905 16.2957 17.1959 15.5466C17.5579 15.1661 17.795 14.6832 17.8751 14.1631V7.21629C16.8473 6.95726 15.8441 6.60842 14.8769 6.17377C13.8598 5.73587 12.8854 5.20421 11.9661 4.58563C10.1559 5.75622 8.17549 6.63712 6.09582 7.19678H6.13464Z"
      fill="#4D5160"
    />
    <g clipPath="url(#clip0_6406_16801)">
      <path
        d="M7.95424 11.8366C7.79304 12.0037 7.79304 12.2676 7.95424 12.4347L10.8289 15.4138C10.8715 15.458 10.9425 15.458 10.9852 15.4138L16.0458 10.1693C16.207 10.0022 16.207 9.73826 16.0458 9.5712L15.4105 8.91284C15.2399 8.73609 14.956 8.73609 14.7854 8.91284L10.9852 12.8512C10.9425 12.8954 10.8715 12.8954 10.8289 12.8512L9.21459 11.1782C9.04404 11.0015 8.76008 11.0015 8.58952 11.1782L7.95424 11.8366Z"
        fill="#4D5160"
      />
    </g>
    <defs>
      <clipPath id="clip0_6406_16801">
        <rect
          width="8.33333"
          height="8.33333"
          fill="white"
          transform="translate(7.83334 8.08594)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Shield;
